<template>
    <md-modal-dialog>

      <md-dialog-title>
        <div>
          <b>Re-authenticate</b>
          &nbsp;&nbsp;
          <md-progress-spinner 
            v-if="loading"
            :md-diameter="17" 
            :md-stroke="2" 
            md-mode="indeterminate" 
            />
        </div>
        <md-subheader>
          Looks like your session expired, please login to complete the action.
        </md-subheader>
        TODO: Actually implement login logic
      </md-dialog-title>

      <md-dialog-content>

        <md-field class="md-form-group">
          <md-icon>face</md-icon>
          <label>User Name...</label>
          <md-input v-model="username"></md-input>
        </md-field>

        <md-field class="md-form-group">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>

      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-flat" @click="onCancel">Cancel</md-button>
        <md-button class="md-primary md-flat" @click="onLogin">Login</md-button>
      </md-dialog-actions>

    </md-modal-dialog>
</template>

<script>

import ValidatedInputs from '@/components/ValidatedInput';
import { LoginCard } from "@/components";

export default {
  components: {
    ...ValidatedInputs,
    LoginCard,
  },
  props: {},
  computed: {},
  data() {
    return {
      username: '',
      password: '',
      loading: false,
    };
  },
  methods: {
    onCancel(){
      this.loading = false;
    },
    onLogin(){
      console.log('onLogin');
      this.loading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";

  .md-subheader {
    padding: 0px;
  }

</style>
